var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.862 3.7361C14.8713 3.87677 14.8713 4.0181 14.8713 4.1601C14.8713 8.49811 11.5687 13.5001 5.53133 13.5001V13.4974C3.748 13.5001 2.00133 12.9894 0.5 12.0261C0.759333 12.0574 1.02 12.0728 1.28133 12.0734C2.76 12.0748 4.196 11.5788 5.358 10.6654C3.95333 10.6388 2.72133 9.72277 2.29133 8.38544C2.78333 8.48011 3.29 8.46077 3.77333 8.32944C2.24133 8.02011 1.14 6.67411 1.14 5.11144C1.14 5.09744 1.14 5.08344 1.14 5.0701C1.59667 5.32477 2.10733 5.46544 2.63 5.48077C1.18733 4.51744 0.742 2.59877 1.61333 1.09877C3.28 3.14944 5.73933 4.39611 8.37867 4.52877C8.114 3.38877 8.476 2.19411 9.328 1.39211C10.65 0.148772 12.7293 0.212772 13.9727 1.53477C14.708 1.39011 15.4127 1.12011 16.0573 0.738105C15.812 1.49811 15.2993 2.14344 14.614 2.55411C15.2653 2.4761 15.9007 2.3021 16.5 2.03677C16.0593 2.69611 15.5047 3.27144 14.862 3.7361Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.a14235c70da2389063477433124ecb53.svg";
export { ForwardRef as ReactComponent };